import * as React from "react";
import styleable from "react-styleable";

import * as inputStyle from '../../../css/components/mainlayout/PortalInput.css';

/**
 * ## styleable
 * * **label** Styling for the label.
 * * **input** Styling for the input box.
 *
 * ## CSS styling
 * * **.wcrc-textinput** override styling of the text input (also affects styling of text input in pages/mainlayout)
 */
class PortalInput extends React.Component<any, any> {

    constructor(){
        super(undefined); // TODO: undefined
        this.state = {
            value: "",
        }
    }

    componentWillMount(){
        if(this.props.value !== undefined){
            this.setState({
                value: this.props.value
            });
        }
    }

    render() {

        let val = this.state.value;
        if((this.props.passive === undefined || this.props.passive === false) && this.props.value !== undefined) // To be used (passive === true) when content should not be updated when the value prop changes.
            val = this.props.value;

        return (
            <span>
                <i className={this.props.css.label}>{this.props.placeholder}</i>
                <input type={this.props.type ?? "text"} className={"wcrc-textinput " + this.props.css.input} placeholder={this.props.placeholder} autoFocus={this.props.autoFocus} value={val} onChange={(e) => {
                    if(this.props.onChange !== undefined){
                        this.props.onChange(e.target.value);
                    }
                    this.setState({value: e.target.value});
                }} onBlur={(e)=>{
                    if(this.props.onBlur !== undefined){ 
                        this.props.onBlur(e.target.value);
                    }
                }}/>
            </span>
        );
    }
}
export default styleable(inputStyle)(PortalInput);